import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GET_CASE_SEARCH_PAGE_REFERENCE_DATA = 'GET_CASE_SEARCH_PAGE_REFERENCE_DATA';


export const service = async () => {
  const options: object = {
    url:  '/api/EaCaseSearchApiController/GetReferenceData',
    method: "GET",
    ...getDefaultOptions(),
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CASE_SEARCH_PAGE_REFERENCE_DATA, service, mock);
